import { getWidthPercents, getPrimaryColor, getPrimaryTextColor } from '../../utils';

export const Footer = (text: string) => (index: number) => `
<mj-column border-radius="10px" background-color="${getPrimaryColor()}" width="${getWidthPercents(index)}" padding-top="3px" padding-bottom="3px">
    <mj-text style="font-size: 14px; font-weight: normal; color: ${getPrimaryTextColor()}">
        ${text}
    </mj-text>
</mj-column>
`;
